export const DeleteEntitygeometryByFulluid = `
    mutation deleteEntitygeometryByFullUid ($fullUid: String!) {
        deleteEntitygeometryByFullUid (input: {fullUid: $fullUid})  {
            entitygeometry {
                fullUid
            }
        }
    }
`
